import { getMerchantDefaultPath } from "./merchantNavigation";

export function getHomepageRedirectPath({
  userType,
  merchantRole,
  merchantCompanyTypes,
  customerHasWarehouseEntry,
}) {
  if (userType === "customer") {
    // Müşteri artık yönlendirilmez: /homepage kendisi müşteri anasayfasını render eder.
    return "";
  }

  if (userType === "merchant") {
    // merchantRole hidrasyonu bitmeden karar verilmez (yanlış sayfaya kısa süreli sıçrama olmasın).
    if (getMerchantDefaultPath({ merchantRole, merchantCompanyTypes }) === null) return null;
    // Merchant da artık yönlendirilmez: /homepage iş ortağı anasayfasını render eder.
    return "";
  }

  if (userType === "admin") return "/users";

  return "";
}
